import React from "react";
import { Building } from "lucide-react";
import { useTranslation } from "react-i18next";

const OrgCompanyRoot = ({ companyLogoUrl, companyLegalName, companyPrimaryColor, selectedDepartementId, onSelect }) => {
  const { t } = useTranslation();
  return (
  <div
    className="relative rounded-xl p-6 text-center transition-colors cursor-pointer overflow-hidden"
    style={{
      backgroundColor: selectedDepartementId === null ? "var(--lm-s2)" : "var(--lm-s1)",
      border: selectedDepartementId === null ? "1px solid #5e6ad2" : "1px solid var(--lm-border)",
    }}
    onClick={() => onSelect(null)}
  >
    <div className="flex flex-col items-center space-y-2">
      <div className="p-3 rounded-full" style={{ backgroundColor: "var(--lm-s2)", border: "1px solid var(--lm-border)" }}>
        {companyLogoUrl ? (
          <img
            src={companyLogoUrl}
            alt={`Logo ${companyLegalName}`}
            className="h-14 w-14 object-contain"
            onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "block"; }}
          />
        ) : null}
        <Building
          className="h-8 w-8"
          style={{
            color: selectedDepartementId === null ? companyPrimaryColor : "#6b7280",
            display: companyLogoUrl ? "none" : "block",
          }}
        />
      </div>
      <div className="space-y-1">
        <span
          className="block text-lg font-extrabold tracking-tight text-foreground "
          style={{ color: selectedDepartementId === null ? companyPrimaryColor : undefined }}
        >
          {companyLegalName}
        </span>
        <div className="mx-auto h-0.5 w-10 rounded-full" style={{ backgroundColor: `${companyPrimaryColor}66` }} />
        <p className="text-xs text-muted-foreground  font-medium">{t('org.allEmployees', 'All employees')}</p>
      </div>
    </div>
  </div>
  );
};

export default OrgCompanyRoot;
